import axiosapi from "./axiosAPI";

// Get All EmploymentStatus
export const getAllEmploymentStatuses = async (
    setEmploymentStatuses,
    setFetcherror,

) => {
    
	try{
		const res =await axiosapi.get("/employmentStatus");
        setEmploymentStatuses(res.data.data ? res.data.data : {});

	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch EmploymentStatus");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch EmploymentStatus");
		}
		
	}
	
};



// Get One EmploymentStatus
export const getOneEmploymentStatus = async (
    pkid,
    setFetcherror,  
    setEmploymentStatus
    
)=>{
	try{
		const res =await axiosapi.get(`/employmentStatus/${pkid}`);
        setEmploymentStatus(res.data.body);
       
	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch EmploymentStatus");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch EmploymentStatus");
		}
		
	}
	
};


// Create New EmploymentStatus
export const createEmploymentStatus = async (
    employmentStatus,
    setEmploymentStatus,
    setFetcherror,
    handleAllToasts,
    setEmploymentStatuses

) => {


    if (!employmentStatus ) {
        handleAllToasts(2, "No EmploymentStatus Provided"); 
            return; 
        }

    const PushItem = {
            name: employmentStatus,
        };

    try{
        await axiosapi.post("/employmentStatus/",PushItem );
        setEmploymentStatus("");
        handleAllToasts(1, "EmploymentStatus Created Successfully");
        getAllEmploymentStatuses(setEmploymentStatuses, setFetcherror);
    }
    catch(err){
        if(err.response){
            //Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Could Not Create New EmploymentStatus");
            handleAllToasts(2, "Could Not update The EmploymentStatus");
            
            
        }else{
            //No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Could Not Create New EmploymentStatus");
            handleAllToasts(2, "Could Not update The EmploymentStatus");
            
        }
        
    }
    
}


// Edit Existing EmploymentStatus

export const editEmploymentStatus = async (
    employmentStatuspkid,
    employmentStatus,
    setEmploymentStatus,
    setFetcherror,
    handleAllToasts,
    setEmploymentStatuses
              
        ) => {

            if (!employmentStatus) {
                handleAllToasts(2, "No EmploymentStatus Name Provided"); 
                    return;  
                }

            const PushItem = {

                    id:employmentStatuspkid,
                    name: employmentStatus,
                };

            try{
                await axiosapi.patch("/employmentStatus/",PushItem );
                setEmploymentStatus("");
                handleAllToasts(1, "EmploymentStatus Updated Successfully");
                getAllEmploymentStatuses(setEmploymentStatuses, setFetcherror);
            }
            catch(err){
                if(err.response){
                    //Error Obtained from Backend not in 200
                    console.log(err.response.data);
                    console.log(err.response.status);
                    console.log(err.response.headers);
                    setFetcherror("Could Not Update EmploymentStatus");
                    handleAllToasts(2, "Could Not Update EmploymentStatus");
                    
                    
                }else{
                    //No response Obtained from the server.
                    console.log(`Error: ${err.message}`);
                    setFetcherror("Could Not Update EmploymentStatus");
                    handleAllToasts(2, "Could Not Update EmploymentStatus");
                    
                }
                
            }
            
};



// Delete Existing EmploymentStatus.

export const deleteEmploymentStatus = async (
    employmentStatuspkid,
    setEmploymentStatuses,
    setFetcherror,
    handleAllToasts
)=>{
    try {
        const res = await axiosapi.delete(`/employmentStatus/${employmentStatuspkid}`);
        let finalData = res.data.message;
        getAllEmploymentStatuses(setEmploymentStatuses, setFetcherror);
        handleAllToasts(1, "EmploymentStatus Deleted Successfully");
        console.log("Deleted:", finalData);
    }
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
			console.log(err.response.data);
			console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Delete EmploymentStatus");
            handleAllToasts(2,"Error: Could Not Delete EmploymentStatus");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Delete EmploymentStatus");
            handleAllToasts(2,"Error: Could Not Delete EmploymentStatus");
		}
		
	}
	
};